const graphemeSegmenter =
  typeof Intl !== "undefined" && "Segmenter" in Intl
    ? new Intl.Segmenter(undefined, { granularity: "grapheme" })
    : null;

// Counts characters the way a user sees them: an emoji (even a multi-part
// one like 👍🏽) is 1, and leading/trailing spaces don't count since they're
// trimmed before saving.
export const countCharacters = (value: string) => {
  const trimmed = value.trim();
  return graphemeSegmenter
    ? Array.from(graphemeSegmenter.segment(trimmed)).length
    : Array.from(trimmed).length;
};
